module.exports = __webpack_public_path__ + "assets/img/person.4bf41230.svg";